<template>
<section class="lives container-fluid">
    <div class="row tit-lives">
      <div class="col-12 text-center">
        <h1>{{ $configEmpresa.textosConfiguraveis.textoDisplayLivesJaleko }}</h1>
      </div>
    </div>
    <div id="lives">
     <div ref="refLive" class="video-live row">
      <div :class="[liveAtiva ? 'col-12 col-md-8 p-0' : 'col-12 offset-md-2 col-md-8 p-0']">
        <div class="embed-responsive embed-responsive-16by9">
          <iframe ref="iframeLive" class="embed-responsive-item" src="" frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
          </iframe>
        </div>
      </div>
      <div class="col-12 col-md-4 p-0">
        <iframe id="iframeChat" ref="iframeChat" class="chat-yt" src=""></iframe>
      </div>
     </div>
     <div  class="container">
      <div class="row justify-content-center mt-5">
        <div v-for="live in lives" class="col-12 col-md-6">
          <div class="card-live">
            <div class="d-flex align-items-center justify-content-between">
                <p>Prof. {{ live.professor }}</p>
                <p>{{ live.datahora_prevista_inicio }}</p>
            </div>
            <h3>{{ live.live }}</h3>
            <div class="text-center">
              <a href="#" class="btn btn-primary d-inline-flex align-items-center">
                  <img :src="imagemIniciarLives" alt="ícone live streaming">
                  <span @click="carregarLive(live.url_video,'live')">Assistir ao vivo</span>
              </a>
            </div>
          </div>
        </div>
      </div>
        <h2 v-if= "proximas.length > 0">Próximas Lives</h2>
        <div class="row">
            <div v-for="proxima in proximas" class="col-12 col-md-4">
              <div class="card-live">
                <div class="d-flex align-items-center justify-content-between">
                  <p>Prof. {{ proxima.professor }}</p>
                </div>
                <h3>{{ proxima.live }}</h3>
                <div class="text-center dh-live">
                  <p>{{ proxima.datahora_prevista_inicio }}</p>
                </div>
              </div>
            </div>
        </div>
        <h2 v-if= "realizadas.length > 0">{{ $configEmpresa.textosConfiguraveis.textoDisplayLivesRealizadas }}</h2>
        <div class="row">
          <div v-for="realizada in realizadas" class="col-12 col-md-4">
            <div class="card-live">
              <div class="d-flex align-items-center justify-content-between">
                  <p>Prof. {{ realizada.professor }}</p>
                  <p>{{ realizada.datahora_prevista_inicio }}</p>
              </div>
              <h3>{{ realizada.live }}</h3>
              <div class="text-center">
                <a href="#" class="btn btn-secondary" @click="carregarLive(realizada.url_video,'')">
                  <i class="fas fa-play" @click="carregarLive(realizada.url_video,'')"></i>
                  Assistir
                </a>
              </div>
            </div>
          </div>
        </div>
     </div>
    </div>
</section>
</template>

<script>
import LiveAPI from '@/api/live-api'
import EventoAPI from '@/api/evento-api'
import ResponseUtils from '@/core/utils/response-utils'
import DateUtils, { DateConstants } from '@/core/utils/date-utils'
import ImageUtils from '@/core/utils/image-utils'
import LoginUtils from '@/core/utils/login-utils'
import { mapState } from 'vuex'

export default {
  name: 'LivesView',

  data () {
    return {
      lives: [],
      realizadas: [],
      proximas: [],
      liveAtiva: false,
      usuario: []
    }
  },
  computed: {
    ...mapState({
      modoNoturno: (state) => state.modoNoturno
    }),
    imagemIniciarLives () {
      if (this.modoNoturno) {
        return this.urlImagem('img/live-streaming-dark.png')
      } else {
        return require('@/assets/img/live-streaming.svg')
      }
    }
  },
  mounted () {
    LiveAPI.listarLives().then(data => {
      this.lives = []
      this.proximas = []
      this.realizadas = []
      if (data) {
        if (data.lives && data.lives.length) {
          this.lives = [...data.lives.map(item => {
            return {
              live: item.live,
              professor: item.professor,
              url_video: item.url_video,
              datahora_prevista_inicio: DateUtils.formatDate(item.datahora_prevista_inicio, DateConstants.DD_MM_YYYY)
            }
          })]
        }
        if (data.proximas && data.proximas.length) {
          this.proximas = [...data.proximas.map(item => {
            return {
              live: item.live,
              professor: item.professor,
              url_video: item.url_video,
              datahora_prevista_inicio: DateUtils.formatDate(item.datahora_prevista_inicio, DateConstants.DD_MM_YYYY_HH_MM)
            }
          })]
        }
        if (data.realizadas && data.realizadas.length) {
          this.realizadas = [...data.realizadas.map(item => {
            return {
              live: item.live,
              professor: item.professor,
              url_video: item.url_video,
              datahora_prevista_inicio: DateUtils.formatDate(item.datahora_prevista_inicio, DateConstants.DD_MM_YYYY)
            }
          })]
        }
      }
    }).catch(error => ResponseUtils.handleError(error))

    this.$refs.refLive.style.display = 'none'
    this.obterDadosUsuario()
  },

  methods: {
    carregarLive: function (videoUrl, origem) {
      const ultimaBarra = videoUrl.lastIndexOf('/')
      const codigoVideo = ultimaBarra > -1 ? videoUrl.slice(ultimaBarra + 1) : 0
      videoUrl = 'https://www.youtube.com/embed/' + codigoVideo
      const chatUrl = origem === 'live' ? 'https://www.youtube.com/live_chat?v=' + codigoVideo + '&embed_domain=' + document.domain : ''
      this.liveAtiva = origem === 'live'
      this.$refs.iframeChat.setAttribute('src', chatUrl)
      this.$refs.iframeLive.setAttribute('src', videoUrl)
      this.$refs.refLive.style.display = 'flex'
      this.registraCliquesDeLive(videoUrl)
    },
    urlImagem: function (url) {
      return ImageUtils.obterUrlCompletaImagem(url)
    },
    obterDadosUsuario: function () {
      this.usuario = LoginUtils.getUsuario()
    },
    registraCliquesDeLive: function (url) {
      let event = 'CliqueLive'
      let sourceSystem = 'Plataforma B2B'
      let sourceUrl = window.location.host
      let userEmail = this.usuario.email
      let userExternalId = this.usuario.id
      let userName = this.usuario.name
      let planoUsuario = this.usuario.planoPrincipal.nomeExibicaoPrincipal
      let perfilUsuario = this.usuario.perfilUsuario.descricao
      let userUuid = LoginUtils.getUuid()

      EventoAPI.registrarClique(event, sourceSystem, sourceUrl, userEmail, userExternalId, userName, url, planoUsuario, perfilUsuario, userUuid)
    }
  }
}

</script>
